export default {
  loading: false,
  stat_data: [],
  recently_added_items: [],
  stock_alerts: [],
  announcement_msg: null,
  total: 0,
  FilteredCount: 0
}
